// ========================================
// CONFIGURAÇÃO DO TEMPLATE
// ========================================
// Modifique apenas os valores abaixo para personalizar sua aplicação

const CONFIG = {
  // Informações básicas do evento
  eventInfo: {
    title: "Halloween PD Castelo 2025",
    subtitle: "🎃👻🦇 Prepare-se para a noite mais assustadora do ano! 🦇👻🎃",
    date: "31 de Outubro de 2025",
    time: "19:00h às 23:00h",
    location: "PD Castelo"
  },
  // Descrição completa do evento
  eventDescription: {
    intro: "Chegou a noite mais assustadora do ano! Nossa escola de forró se transforma em uma festa de arrepiar com muita dança, comida e diversão! 🎃👻🕷️",
    cards:[
      {
        title:"🍔 Comidas e Guloseimas",
        items:[
          "Comida e guloseimas temáticas"
        ],
        color:"orange"
      },
      {
        title:"🍹 Bebidas",
        items:[
          "Chopp",
          "Venm (Laut)",
          "Bebidas misteriosas"
        ],
        color:"orange"
      },
      {
        title:"🎭 Atividades Arrepiantes",
        items:[
          "Concurso de Fantasias (premiação)",
          "Jack & Jill Assombrado"
        ],
        color:"purple"
      },
      {
        title:"⚠️ Observações Importantes",
        items:[
          "⚠️ Fantasias não são obrigatórias, mas é bem legal entrar na brincadeira!",
          "⚠️ Menores de 18 anos só podem permanecer com responsável legal."
        ],
        color:"yellow"
      }
    ]
  },

  // Configurações de pagamento
  payment: {
    pixEmail: "eventospdcastelo@gmail.com",
    pixMessage: "Caso o QR code não funcione, faça o PIX para: eventospdcastelo@gmail.com",
    comprovanteWarning: "⚠️ ATENÇÃO: Sua compra só será efetivada após anexar o comprovante de pagamento."
  },

  // Configurações do Google Apps Script
  googleAppsScript: {
    // Substitua pelo ID do seu projeto Google Apps Script
    appId: "SEU_APP_ID_AQUI",
    
    // Nomes das abas no Google Sheets (não altere se usar a estrutura padrão)
    sheets: {
      ingressos: "ingressos",
      token: "token"
    }
  },

  // Configurações visuais (opcional)
  styling: {
    primaryColor: "#4F46E5", // Cor principal (índigo)
    secondaryColor: "#10B981", // Cor secundária (verde)
    accentColor: "#F59E0B" // Cor de destaque (amarelo)
  }
};

// ========================================
// NÃO MODIFIQUE ABAIXO DESTA LINHA
// ========================================
export default CONFIG; 